import { render } from "./Results_ClinicalSignificance.vue?vue&type=template&id=752f488c"
import script from "./Results_ClinicalSignificance.vue?vue&type=script&lang=js"
export * from "./Results_ClinicalSignificance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__